
const RecoveryCourtSection: React.FC<{
  hasCourtData: boolean;
  referral: any;
  onOpenCourtPopup: () => void;
//   onForwardToCoordinator: () => void;
  isEditMode:boolean
  isEditing:boolean,
  isAssetRegistrar:boolean
  onEditClick:()=>void
}> = ({ hasCourtData, referral, onOpenCourtPopup,isAssetRegistrar,isEditMode,isEditing,onEditClick }) => {
  return (
    <div className="">

      {hasCourtData ? (
        <>
          {/* <CourtDisplay referral={referral} isAssetRegistrar={isAssetRegistrar} isEditMode={isEditMode} isEditing={isEditing} 
          onEditClick={onEditClick}/> */}
          
        </>
      ) : (
        <div className="">
          <button
            onClick={onOpenCourtPopup}
            className="referral-form-button text-white"
            style={{ fontSize: "14px", padding: "10px" }}
          >
            + Add Court Details
          </button>
        </div>
      )}
    </div>
  );
}
export default RecoveryCourtSection;
